import { createApp } from 'vue';
import Mapa from './components/Mapa.vue';

let mapa = document.querySelector('.mapa-container')
if (mapa !== null) {
    
    let lat = mapa.getAttribute('lat');
    let lng = mapa.getAttribute('lng');
    let codigo = mapa.getAttribute('codigo');

    createApp(Mapa, {
        lat,
        lng,
        codigo
    }).mount(mapa)

}
